/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import GoodbyeGroupView from './GoodbyeGroup.view';
import routeNames from 'lib/routeNames';


const GoodbyeGroupPresenter = (props) => (
  <GoodbyeGroupView
    goHome={routeNames.home()}
  />
);

export default GoodbyeGroupPresenter;